/**
 * @description Module recherche de l'en-tête
 */

/* global bsBreakpoints */

(() => {
	// VARS
	const root = document.querySelector('[data-js-header-search-root]') || null;
	const toggleBtn =
		document.querySelector('[data-js-header-search-toggle]') || null;
	const content = document.querySelector('#edit-text');
	if (root) {
		root.insertAdjacentHTML(
			'beforeend',
			'<div class="search-overlay"></div>'
		);
	}
	const searchOverlay = document.querySelector('.search-overlay');
	const searchBtn = document.querySelector('#edit-submit-main-search-engine');

	// FONCTIONS
	const toggle = () => {
		toggleBtn.addEventListener('click', () => {
			if (toggleBtn.getAttribute('data-icon') === 'search') {
				toggleBtn.setAttribute('data-icon', 'cross');
				toggleBtn.setAttribute('aria-expanded', true);
				content.style.display = 'block';
				searchOverlay.style.display = 'block';
				searchBtn.style.display = 'block';
			} else {
				toggleBtn.setAttribute('data-icon', 'search');
				toggleBtn.setAttribute('aria-expanded', false);
				content.style.display = 'none';
				searchOverlay.style.display = 'none';
				searchBtn.style.display = 'none';
			}
		});
	};

	// GO 🚀
	const init = () => {
		if (
			bsBreakpoints.detectBreakpoint() === 'xSmall' ||
			bsBreakpoints.detectBreakpoint() === 'small' ||
			bsBreakpoints.detectBreakpoint() === 'medium'
		) {
			if (toggleBtn) {
				toggleBtn.setAttribute('data-icon', 'search');
			}

			if (document.body.contains(root)) {
				toggle();
			}
		}
	};

	init();
})();
